<template>
    <div>
        <Modal v-model="show" title="更新备注" :footer-hide="true" width="400">

            <div class="update_job_div">
                <span class="update_job_div_span">备注：</span>

                <Input v-model="remarks_text" placeholder="输入备注" style="width: 250px" />
            </div>
            <div class="update_job_butotn">
                <Button type="primary" @click="click_update">确认更新</Button>

            </div>

        </Modal>

    </div>
</template>

<script>
import { http } from "@/utils/http.js";

export default {
    name: "update_remarks",
    data() {
        return {
            show: false,
            
            project_id: "",
            resume_id:'',
            interview_id:'',
            
            remarks_text: "",
            
        }
    },
    methods: {
        // 更新岗位
        click_update() {
            var that = this
            var obj = {
                interview_id: this.interview_id,
                resume_id: this.resume_id,
                project_id: this.project_id,
                remarks: this.remarks_text,
            }
            http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/update_remarks", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });

                        that.show = false
                        that.$emit('change', 1)
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        // 更新岗位
        open(project_id, row) {
            this.project_id = project_id
            this.resume_id = row.resume_id
            this.interview_id = row.interview_id

            this.show = true
            this.remarks_text = row.remarks
            
          
        },

    }

}
</script>

<style  scoped>
.update_job_butotn {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
}

.update_job_div_span {
    font-size: 14px;
    color: #333;
    margin-right: 10px;
}

.update_job_div {
    display: flex;
    align-items: center;
}
</style>